import { useContext } from 'react';
import { translateSync } from '../services/translationService';
import { LanguageContext } from '../contexts/LanguageContext';

export function useTranslation() {
    const { currentLang } = useContext(LanguageContext);
    
    const t = (text, variables = {}, options = {}) => {
        let key = text;
        
        // Handle pluralization
        if (options.count !== undefined) {
            const plural = options.count === 1 ? 'one' : 'other';
            key = `${text}_${plural}`;
        }
        
        const translated = translateSync(key, currentLang);
        return translated.replace(/\{\{(\w+)\}\}/g, (match, key) => {
            return variables[key] ?? match;
        });
    };

    return t;
} 